import { createAction } from "redux-actions";

export const ANIMATE_ACTIONS = {
    SWITCH_HERO_STATS_DISPLAY_PLAYER_IMG_DAMAGE: 'animate switch heroStatsDisplay player img damage',
}

export const animateActions = {
    switchHeroStatsDisplayPlayerImgDamage: createAction(ANIMATE_ACTIONS.SWITCH_HERO_STATS_DISPLAY_PLAYER_IMG_DAMAGE)
} 